import React from "react";
import {enableTool} from "../actions/wizard";
import { connect } from "react-redux";
import LowerRailComponent from '../components/Topbar/LowerRailComponent'
import UpperRailComponent from '../components/Topbar/UpperRailComponent'


 class TopbarContainer extends React.Component<any, any>{
    render(){
        return(
            <div className={'topBar'}>
                <UpperRailComponent/>
                <LowerRailComponent />

            </div>

        )
    }

}
export default connect(
    (state: any) => ({
    }),
    {
        enableTool
    }
)(TopbarContainer);
